import React from "react"
import styled from "styled-components"
import { graphql } from "gatsby"
import _ from "lodash"

import Layout from "../components/layout"
import BlogCard from "../components/postCard"
import AboutMe from "../components/aboutMe_home"
import SEO from "../components/seo"
import Tags from "../components/tags"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: grid;
    grid-template-columns: 60% 5% 35%;
    max-width: 1024px;
  }

  div.content_left {
    padding: 20px;

    & h2 {
      font-size: 36px;
      font-weight: 900;
      color: #fff;

      @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.fontSizes.md};
      }
    }
  }

  div.content_right {
    grid-column-start: 3;
    padding: 20px;
    margin: 0 auto;
  }
`

const IndexPage = props => {
  const blogs = props.data.post.edges
  const about = props.data.about

  const featuredBlogs = blogs.filter(blog => blog.node.featured === true)

  const allTags = []

  blogs.forEach(blog => {
    let tags = blog.node.tags
    if (blog.node.tags) {
      tags.forEach(tag => {
        allTags.push(tag.name)
      })
    }
  })

  return (
    <Layout>
      <SEO title="Home" />
      <Wrapper>
        <div className="content_left">
          <h2>Featured Blog</h2>
          {featuredBlogs.map(blog => {
            return (
              <BlogCard
                {...blog.node}
                key={blog.node.id}
                link={`blog/${blog.node.slug.current}`}
              />
            )
          })}
        </div>
        <div className="content_right">
          <AboutMe about={about} />
          <Tags tags={_.uniq(allTags)} />
        </div>
      </Wrapper>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query homePageQuery {
    post: allSanityPost {
      edges {
        node {
          publishedAt
          featured
          summary
          slug {
            current
          }
          title
          tags {
            id
            name
          }
          id
          mainImage {
            asset {
              fixed(width: 600, height: 200) {
                ...GatsbySanityImageFixed
              }
              fluid(maxWidth: 400) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
    }
    about: sanityAbout {
      facebook
      id
      instagram
      name
      twitter
      profile_picture {
        asset {
          fixed(width: 600, height: 200) {
            ...GatsbySanityImageFixed
          }
          fluid(maxWidth: 400) {
            ...GatsbySanityImageFluid
          }
        }
      }
      introduction
    }
  }
`
